import {
  fetchWithTokenAndRegion,
  getAdminApiUrl,
  getCurrentToken,
  getCurrentTokenWithoutRedirect,
  getOxygenId,
} from '@adsk/acs-sc-web-platform-api';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  createDataStore,
  DataStore,
} from '../helpers/createDataModificationStore';
import { Subscription } from '../types';

export type SubscriptionStore = DataStore<SubscriptionResponse>;

type SubscriptionResponse = {
  results: Subscription[];
};

const fetchSubscriptions = async () => {
  await getCurrentTokenWithoutRedirect();
  const { accessToken } = await getCurrentToken();
  const oxygenId = getOxygenId(accessToken);
  return await fetchWithTokenAndRegion<SubscriptionResponse>(
    `${getAdminApiUrl()}/internal/v1/users/${oxygenId}/subscriptions?filter[status]=active,expired`,
  );
};

export const useSubscriptionsStore = () =>
  createDataStore<SubscriptionResponse>({
    contextName: CONTEXT_NAMES.SubscriptionsContext,
    fetchFunction: fetchSubscriptions,
  })();
